export const USER_LOGOUT = 'USER_LOGOUT';
export const WAIT_LOGIN = 'WAIT_LOGIN';
export const DO_LOGIN = 'DO_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const RE_LOGIN_SUCCESS = 'RE_LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const WAIT_FORGOT_PWD = 'WAIT_FORGOT_PWD';
export const LOGIN_CLEAR_MSG = 'LOGIN_CLEAR_MSG';
export const TO_OTHER_PAGE = 'TO_OTHER_PAGE';

export const saveLoginData = (idToken, accessToken, account) => (dispatch) => {
    let loginParams = {
        idToken: idToken,
        accessToken: accessToken,
        account: account
    }
    window.sessionStorage.setItem('RangeHood.LoginParams', JSON.stringify(loginParams));

    dispatch({
        type: LOGIN_SUCCESS,
        loginParams: loginParams
    });
}

export const reLoginBySession = () => (dispatch) => {
    const loginParams = JSON.parse(window.sessionStorage.getItem('RangeHood.LoginParams'));

    dispatch({
        type: RE_LOGIN_SUCCESS,
        loginParams: {
            idToken: loginParams.idToken,
            accessToken: loginParams.accessToken,
            account: loginParams.account
        }
    });
}

export const doLogin = () => (dispatch) => {
    dispatch({
        type: DO_LOGIN
    });
}

export const doLoginFail = (errMsg) => (dispatch) => {
    dispatch({
        type: LOGIN_FAIL,
        loginParams: {
            errMsg: errMsg
        }
    });
}

export const forwardForgotPwd = () => (dispatch) => {
    dispatch({
        type: WAIT_FORGOT_PWD
    });
}

export const forwardLogin = (errMsg) => (dispatch) => {
    // return loagin page, clear session login info
    // will keep other reducers state
    sessionStorage.removeItem('RangeHood.LoginParams');

    dispatch({
        type: WAIT_LOGIN,
        loginParams: {
            errMsg: errMsg
        }
    });
}

export const doLogout = () => (dispatch) => {
    // return loagin page, clear session login info
    sessionStorage.removeItem('RangeHood.LoginParams');

    dispatch({
        type: USER_LOGOUT
    });
}

export const clearErrMsg = () => (dispatch) => {
    dispatch({
        type: LOGIN_CLEAR_MSG
    });
}

export const toOtherPage = () => (dispatch) => {
    dispatch({
        type: TO_OTHER_PAGE
    });
}